// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2X62w","label":"Completed_label__1w1wj"};